<div class="card-body">
    <div class="properties-list-toolbar">
        <div class="properties-toolbar-top">
            <div class="properties-toolbar-search">
                <div class="search-box" [class.placeholder-glow]="hideElement">
                    <input type="text" name="searchTerm" class="form-control"
                        [attr.placeholder]="!hideElement ? ('t-search-for'|translate) + ' ' +('t-title'|translate|lowercase) +', ' +('t-reference'|translate|lowercase) +'...':''"
                        [formControl]="queryField" [class.placeholder]="hideElement"
                        [attr.disabled]="hideElement ? true: null">
                    <i class="ri-search-line search-icon" *ngIf="!hideElement"></i>
                </div>
            </div>

            <ng-container *ngIf="!portalExportError?.status">
                <div class="properties-toolbar-actions" [class.placeholder-glow]="hideElement">
                    <button class="btn btn-soft-danger btn-icon" (click)="deleteMultiple()"
                        *ngIf="permissionsService.isRealMaster()" [class.placeholder]="hideElement"
                        [attr.disabled]="countCheckSelected==0 ? true: null" [ngbTooltip]="'t-delete' | translate"
                        container="body">
                        <i class="ri-delete-bin-2-line"></i>
                    </button>

                <app-saved-property-filters *ngIf="propertiesFiltersForm" resource="DEVELOPMENT"
                    [currentFilters]="propertyFilters" [currentFormValue]="currentSavedFilterFormValue"
                    [selectedStatusId]="selectedStatusId" [disabled]="hideElement"
                    [autoApplyDefault]="!isOpenModal" [appliedFilterId]="appliedSavedFilterId"
                    (apply)="applySavedPropertyFilter($event)">
                </app-saved-property-filters>

                    <button *appHasPermission="'CREATE_PROPERTIES'" type="button" class="btn btn-primary add-btn"
                        id="create-btn" (click)="openModal()" [class.placeholder]="hideElement"
                        [attr.disabled]="hideElement ? true: null"><i class="ri-add-line align-bottom me-1"></i>
                        {{ 't-add-development'| translate }}
                    </button>
                </div>
            </ng-container>
        </div>

        <div class="properties-toolbar-quick" *ngIf="!portalExportError?.status">
            <div class="dropdown quick-filter-dropdown" *ngIf="statusList">
                <button type="button" class="quick-filter-btn" [class.has-value]="hasStatusFilter"
                    data-bs-toggle="dropdown" data-bs-auto-close="outside">
                    <i class="ri-checkbox-circle-line"></i>
                    <span>{{ 't-m-properties.t-status' | translate }}</span>
                    <strong class="text-truncate">{{ statusFilterLabel }}</strong>
                    <i class="ri-arrow-down-s-line ms-auto"></i>
                </button>
                <div class="dropdown-menu quick-filter-menu">
                    <button type="button" class="quick-filter-option" *ngFor="let status of statusList"
                        [class.is-selected]="selectedStatusId === status.id" (click)="onChangestatus(status.id)">
                        <span>{{ status.description || status.name }}</span>
                        <i class="ri-check-line" *ngIf="selectedStatusId === status.id"></i>
                    </button>
                </div>
            </div>

            <div class="dropdown quick-filter-dropdown" [formGroup]="propertiesFiltersForm"
                *ngIf="propertiesFiltersForm">
                <button type="button" class="quick-filter-btn" [class.has-value]="locationFilterLabel"
                    data-bs-toggle="dropdown" data-bs-auto-close="outside">
                    <i class="ri-map-pin-line"></i>
                    <span>{{ 't-m-properties.t-location' | translate }}</span>
                    <strong class="text-truncate" *ngIf="locationFilterLabel">{{ locationFilterLabel }}</strong>
                    <i class="ri-arrow-down-s-line ms-auto"></i>
                </button>
                <div class="dropdown-menu quick-filter-menu quick-filter-menu-xl">
                    <div class="quick-filter-cascade">
                        <div class="quick-filter-column">
                            <div class="quick-filter-column-header">
                                <span class="quick-filter-column-title">
                                    <i class="ri-map-pin-line"></i>
                                    {{ 't-m-properties.t-district' | translate }}
                                </span>
                                <small *ngIf="propertiesFiltersForm.get('district')?.value?.length">{{
                                    propertiesFiltersForm.get('district')?.value?.length }}</small>
                            </div>
                            <div class="quick-filter-options">
                                <button type="button" class="quick-filter-option" *ngFor="let district of districts"
                                    [class.is-selected]="isQuickFormArrayValueSelected('district', district.id)"
                                    (click)="toggleQuickFormArrayValue('district', district.id)">
                                    <span>{{ district.name }}</span>
                                    <i class="ri-check-line"
                                        *ngIf="isQuickFormArrayValueSelected('district', district.id)"></i>
                                </button>
                            </div>
                        </div>

                        <div class="quick-filter-column">
                            <div class="quick-filter-column-header">
                                <span class="quick-filter-column-title">
                                    <i class="ri-community-line"></i>
                                    {{ 't-m-properties.t-county' | translate }}
                                </span>
                                <small *ngIf="propertiesFiltersForm.get('county')?.value?.length">{{
                                    propertiesFiltersForm.get('county')?.value?.length }}</small>
                            </div>
                            <div class="quick-filter-options">
                                <button type="button" class="quick-filter-option" *ngFor="let county of counties"
                                    [class.is-selected]="isQuickFormArrayValueSelected('county', county.id)"
                                    (click)="toggleQuickFormArrayValue('county', county.id)">
                                    <span>{{ county.name }}</span>
                                    <i class="ri-check-line"
                                        *ngIf="isQuickFormArrayValueSelected('county', county.id)"></i>
                                </button>
                                <span class="quick-filter-empty-option" *ngIf="!counties?.length">---</span>
                            </div>
                        </div>

                        <div class="quick-filter-column">
                            <div class="quick-filter-column-header">
                                <span class="quick-filter-column-title">
                                    <i class="ri-road-map-line"></i>
                                    {{ 't-m-properties.t-parish' | translate }}
                                </span>
                                <small *ngIf="propertiesFiltersForm.get('parish')?.value?.length">{{
                                    propertiesFiltersForm.get('parish')?.value?.length }}</small>
                            </div>
                            <div class="quick-filter-options">
                                <button type="button" class="quick-filter-option" *ngFor="let item of parish"
                                    [class.is-selected]="isQuickFormArrayValueSelected('parish', item.id)"
                                    (click)="toggleQuickFormArrayValue('parish', item.id)">
                                    <span>{{ item.name }}</span>
                                    <i class="ri-check-line" *ngIf="isQuickFormArrayValueSelected('parish', item.id)"></i>
                                </button>
                                <span class="quick-filter-empty-option" *ngIf="!parish?.length">---</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="dropdown quick-filter-dropdown" [formGroup]="propertiesFiltersForm"
                *ngIf="propertiesFiltersForm">
                <button type="button" class="quick-filter-btn"
                    [class.has-value]="propertiesFiltersForm.get('propertyTypes')?.value?.length"
                    data-bs-toggle="dropdown" data-bs-auto-close="outside">
                    <i class="ri-home-4-line"></i>
                    <span>{{ 't-m-properties.t-property-type' | translate }}</span>
                    <strong class="text-truncate" *ngIf="propertyTypeFilterLabel">{{ propertyTypeFilterLabel }}</strong>
                    <i class="ri-arrow-down-s-line ms-auto"></i>
                </button>
                <div class="dropdown-menu quick-filter-menu quick-filter-menu-lg quick-filter-property-menu">
                    <div class="quick-filter-type-groups">
                        <div class="quick-filter-type-group" *ngFor="let group of getPropertyTypeGroups()">
                            <button type="button" class="quick-filter-type-header"
                            [class.is-selected]="isPropertyTypeGroupSelected(group)"
                            (click)="onQuickPropertyTypeGroupClick($event, group)">
                                <span class="quick-filter-type-title">
                                    <i class="ri-folder-3-line"></i>
                                    <span>{{ group.name }}</span>
                                </span>
                                <small>{{ getPropertyTypeGroupSelectedCount(group) }}/{{ group.items.length }}</small>
                            </button>
                            <div class="quick-filter-subtype-list">
                                <button type="button" class="quick-filter-option quick-filter-subtype-option"
                                *ngFor="let type of group.items"
                                [class.is-selected]="isQuickFormArrayValueSelected('propertyTypes', type.id)"
                                (click)="onQuickFormArrayValueClick($event, 'propertyTypes', type.id)">
                                    <span>{{ type.description }}</span>
                                    <i class="ri-check-line"
                                    *ngIf="isQuickFormArrayValueSelected('propertyTypes', type.id)"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="quick-filter-switch" *ngIf="showMinCommissionPendingFilter"
                [class.has-value]="propertyFilters.minimumCommissionPendingValidation === true">
                <div class="form-check form-switch form-switch-primary form-switch-md mb-0">
                    <input class="form-check-input"
                        [checked]="propertyFilters.minimumCommissionPendingValidation === true"
                        (change)="changeMinCommissionPending($event)" type="checkbox" role="switch"
                        id="SwitchCheckMinCommissionDev">
                    <label container="body" class="form-check-label" for="SwitchCheckMinCommissionDev">
                        <i class="ri-percent-line"></i>
                        {{ 't-developments.t-commission-to-validate' | translate }}
                    </label>
                </div>
            </div>

            <button type="button" class="btn btn-light properties-more-filters" data-bs-toggle="offcanvas"
                href="#offcanvasExample" (click)="showPropertyFilerts = true; openFilters()">
                <i class="ri-filter-3-line align-bottom me-1"></i>
                {{ 't-property-quick-filters.t-advanced'| translate }}
                <span class="badge  ms-1 border">{{countFilters$.getValue()}}</span>
            </button>
        </div>

        <div class="properties-active-filters" *ngIf="activeFilterChips.length > 0">
            <span class="active-filters-label">{{ 't-property-quick-filters.t-active' | translate }}:</span>
            <button type="button" class="active-filter-chip" *ngFor="let chip of activeFilterChips"
                (click)="removeActiveFilter(chip)">
                <i [class]="chip.icon"></i>
                <span>{{ chip.label }}</span>
                <i class="ri-close-line"></i>
            </button>
            <button type="button" class="btn btn-link btn-sm p-0 active-filters-clear"
                (click)="clearAllActiveFilters()">
                {{ 't-clear-filter' | translate }}
            </button>
        </div>
    </div>
    <div class="table-card gridjs-border-none mt-3">
        <div class="table-responsive" *ngIf="properties && total>0">

            <table class="table align-middle">
                <thead>
                    <tr class="bg-light text-muted">
                        <th scope="col" *ngIf="!portalExportError?.status">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="checkAll" value="option"
                                    [(ngModel)]="masterSelected" (change)="checkUncheckAll(true)">
                            </div>
                        </th>
                        <th scope="col" class="text-nowrap" style="width: 30%;">
                            {{ 't-m-properties.t-property'| translate }}
                        </th>
                        <!-- <th scope="col">{{ 't-m-properties.t-reference'| translate }}</th> -->
                        <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                                (click)="onSort('units')">
                                {{ 't-developments.t-units'| translate }}
                                <span class="ms-1">{{ getSortIndicator('units') }}</span>
                            </button>
                        </th>
                        <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                                (click)="onSort('businessType')">
                                {{ 't-m-properties.t-business-type'| translate }}
                                <span class="ms-1">{{ getSortIndicator('businessType') }}</span>
                            </button>
                        </th>
                        <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                                (click)="onSort('price')">
                                {{ 't-m-properties.t-price'| translate }}
                                <span class="ms-1">{{ getSortIndicator('price') }}</span>
                            </button>
                        </th>
                        <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                                (click)="onSort('store')">
                                {{ 't-m-properties.t-store'| translate }}
                                <span class="ms-1">{{ getSortIndicator('store') }}</span>
                            </button>
                        </th>
                        <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                                (click)="onSort('status')">
                                {{ 't-m-properties.t-status'| translate }}
                                <span class="ms-1">{{ getSortIndicator('status') }}</span>
                            </button>
                        </th>
                        <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                                (click)="onSort('updated')">
                                {{ 't-m-properties.t-updated-at'| translate }}
                                <span class="ms-1">{{ getSortIndicator('updated') }}</span>
                            </button>
                        </th>
                        <th scope="col" class="text-nowrap">
                            <button type="button" class="btn btn-link p-0 text-decoration-none text-reset text-nowrap"
                                (click)="onSort('createdAt')">
                                {{ 't-created-at'| translate }}
                                <span class="ms-1">{{ getSortIndicator('createdAt') }}</span>
                            </button>
                        </th>
                        <th scope="col">{{'t-action' | translate}}</th>
                    </tr>
                </thead>
                <tbody *ngIf="!propertyFilters.highlight">
                    <tr *ngFor="let property of properties">
                        <th scope="row" *ngIf="!portalExportError?.status">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="checkAll" value="option1"
                                    [(ngModel)]="property.isSelected" (change)="checkUncheckAll(false)">
                            </div>
                        </th>

                        <td (click)="!property?.isProcessing?openPreviewModal(modalPreview, property):false"
                            [ngClass]="{'cursor-pointer':!property?.isProcessing}">
                            <span>
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3"
                                        [ngClass]="{'placeholder-2':property?.isProcessing}">
                                        <div class="avatar-md bg-light rounded p-1 img-fluid-product position-relative">
                                            <img src="{{property?.image ? pathImage + property.image : 'assets/images/no-image-available1_1.jpeg'}}"
                                                alt="" class="img-fluid d-block" (error)="onImageError($event)">
                                            <img *ngIf="property?.agent?.image" ngbTooltip="{{property?.agent?.name}}"
                                                placement="top" src="{{pathUserImage}}{{property.agent?.image}}"
                                                class="img-agent avatar-xxs" (error)="onUserImageError($event)">
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <span class="fs-13 mb-1" [ngClass]="{'placeholder-2':property?.isProcessing}">
                                            {{property.title}}
                                        </span>
                                        <p class="mb-0" [ngClass]="{'placeholder-2':property?.isProcessing}">
                                            {{ 't-m-properties.t-reference'| translate }} :
                                            <span class="fs-12">
                                                {{property.reference}}
                                                <span [ngbTooltip]="'t-property-has-portals-error' | translate"
                                                    *ngIf="property?.portalLogs && !portalExportError?.isExported"
                                                    class="fw-medium badge badge-soft-danger ms-2">
                                                    <i class="mdi mdi-alert fs-16"></i>
                                                </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </span>
                        </td>
                        <!-- <td (click)="openModal(property)" class="cursor-pointer">{{property.reference}}</td> -->
                        <td>

                            <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                <div class="d-flex align-items-center">
                                    <div class="flex-grow-1">
                                        <p class="mb-0">
                                            {{property?.units}}
                                        </p>
                                    </div>
                                </div>
                            </span>
                        </td>
                        <td class="w-xs">
                            <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{property.businessType?.name}}
                            </span>
                        </td>
                        <td class="w-xs">
                            <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{priceFormat(property.price, property?.currency)}}
                            </span>
                        </td>
                        <td><span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{property.store?.name}}
                            </span></td>
                        <td class="status">
                            <ng-container *ngIf="!property?.isProcessing">
                                <span *ngIf="property?.businessStatus !== prospectingId || property?.status == true"
                                    class="badge text-uppercase"
                                    [ngClass]="{'badge-soft-success':property?.status && !property?.highlight,'badge-soft-danger':!property?.status, 'badge-soft-info': property?.status && property?.highlight}">
                                    <!-- {{property?.status?'Active':'Inactive'}} -->
                                    <ng-container *ngIf="property?.status && !property?.highlight">
                                        {{ 't-m-properties.t-active'| translate }}
                                    </ng-container>
                                    <ng-container *ngIf="property?.status && property?.highlight">
                                        {{ 't-highlight'| translate }}
                                    </ng-container>
                                    <ng-container *ngIf="!property?.status">
                                        {{ 't-m-properties.t-inactive'| translate }}
                                    </ng-container>
                                </span>
                                <span *ngIf="property?.businessStatus == prospectingId && !property?.status"
                                    class="badge text-uppercase badge-soft-warning">
                                    {{ 't-prospecting'| translate }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="property?.isProcessing">
                                <span class="badge text-uppercase badge-outline-info"
                                    ngbTooltip="{{'t-processing-status-is-means-that-the-property-is-being-created-with-more-than-20-images' | translate}}"
                                    placement="top">
                                    {{ 't-processing'| translate }}...
                                </span>
                            </ng-container>

                        </td>
                        <td>
                            <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{createDateFormat(property.updated)}}
                            </span>
                        </td>
                        <td>
                            <span [ngClass]="{'placeholder-2':property?.isProcessing}">
                                {{createDateFormat(property.createdAt)}}
                            </span>
                        </td>
                        <td>
                            <ul class="list-inline hstack gap-2 mb-0">
                                <ng-container *ngIf="!property?.isProcessing">
                                    <li class="list-inline-item" ngbTooltip="{{'t-edit' | translate}}" placement="top"
                                        container="body" *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') 
                                          || permissionsService.canEditProperty(loginUser, property?.store?.id)">

                                        <a class="edit-item-btn text-primary" (click)="openModal(property)"><i
                                                class="ri-pencil-fill align-bottom  fs-16"></i></a>

                                    </li>
                                    <li class="list-inline-item" ngbTooltip="{{'t-view' | translate}}" placement="top"
                                        container="body"
                                        *ngIf="!permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && !permissionsService.canEditProperty(loginUser, property?.store?.id)">
                                        <a class="edit-item-btn text-primary" (click)="openModal(property)"><i
                                                class="ri-eye-line align-bottom  fs-16"></i></a>
                                    </li>
                                    <ng-container *ngIf="!portalExportError?.status">
                                        <li class="list-inline-item" ngbTooltip="{{'t-delete' | translate}}"
                                            container="body" placement="top"
                                            *ngIf="permissionsService.canDeleteProperty(loginUser, property?.store?.id)">
                                            <a class="remove-item-btn text-danger" (click)="confirm(property.id)">
                                                <i class="ri-delete-bin-fill align-bottom"></i>
                                            </a>
                                        </li>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="property?.isProcessing">
                                    <li class="list-inline-item" *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') 
                                          || permissionsService.canEditProperty(loginUser, property?.store?.id)">
                                        <span class="edit-item-btn text-primary"
                                            [ngClass]="{'placeholder-2':property?.isProcessing}"
                                            *ngIf="property?.isProcessing"><i
                                                class="ri-pencil-fill align-bottom  fs-16"></i></span>
                                    </li>
                                    <li class="list-inline-item"
                                        *ngIf="!permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && !permissionsService.canEditProperty(loginUser, property?.store?.id)">
                                        <span class="edit-item-btn text-primary"
                                            [ngClass]="{'placeholder-2':property?.isProcessing}"><i
                                                class="ri-eye-line align-bottom  fs-16"></i></span>
                                    </li>
                                    <ng-container *ngIf="!portalExportError?.status">
                                        <li class="list-inline-item"
                                            *ngIf="permissionsService.canDeleteProperty(loginUser, property?.store?.id)">
                                            <span class="remove-item-btn text-danger"
                                                [ngClass]="{'placeholder-2':property?.isProcessing}">
                                                <i class="ri-delete-bin-fill align-bottom fs-16"></i>
                                            </span>
                                        </li>
                                    </ng-container>
                                </ng-container>
                            </ul>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="propertyFilters.highlight && loginUser.role?.name === 'MASTER'" cdkDropList
                    (cdkDropListDropped)="drop($event)">
                    <tr class="cursor-move" *ngFor="let property of properties" cdkDrag>
                        <th scope="row">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="checkAll" value="option1"
                                    [(ngModel)]="property.isSelected" (change)="checkUncheckAll(false)">
                            </div>
                        </th>

                        <td (click)="openPreviewModal(modalPreview, property)">
                            <span>
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar-md bg-light rounded p-1 img-fluid-product position-relative">
                                            <img src="{{pathImage}}{{property.image}}" alt="" class="img-fluid d-block">
                                            <img *ngIf="property?.agent?.image" ngbTooltip="{{property?.agent?.name}}"
                                                placement="top" src="{{pathUserImage}}{{property.agent?.image}}"
                                                class="img-agent avatar-xxs" (error)="onUserImageError($event)">
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <span class="fs-13 mb-1">
                                            {{property.title}}
                                        </span>
                                        <p class="mb-0">
                                            {{ 't-m-properties.t-reference'| translate }} :
                                            <span class="fs-12">
                                                {{property.reference}}
                                            </span>
                                        </p>
                                        <!-- <p class="text-muted mb-0" *ngIf="property?.mediation">
                                            {{ 't-m-properties.t-mediation'| translate }} :
                                            <span class="fw-medium badge"
                                                [ngClass]="{'badge-soft-danger':!isDateAvailable(property.mediation),'badge-soft-success':isDateAvailable(property.mediation)}">
                                                {{createDateFormat(property.mediation)}}
                                            </span>
                                        </p> -->
                                    </div>
                                </div>
                            </span>
                        </td>
                        <!-- <td (click)="openModal(property)" class="cursor-pointer">{{property.reference}}</td> -->
                        <td>

                            <span>
                                <div class="d-flex align-items-center">
                                    <div class="flex-grow-1">


                                        <p class="mb-0">
                                            {{property.propertyType?.name}}
                                            {{property.propertyType2?.name?':':''}}
                                            <span class="fs-12" *ngIf="property.propertyType2?.name">
                                                {{property.propertyType2?.name}}
                                            </span>
                                        </p>

                                        <p class="text-muted mb-0" *ngIf="property.associatedProperty">
                                            <!-- {{property?.propertyType?.type===2?'Development ':'Property '}}
                                            associated : -->
                                            <ng-container *ngIf="property?.propertyType?.type===2">
                                                {{
                                                't-m-properties.t-associated-development'|
                                                translate }}:
                                            </ng-container>
                                            <ng-container *ngIf="property?.propertyType?.type!==2">
                                                {{ 't-m-properties.t-associated-property'|
                                                translate }}:
                                            </ng-container>
                                            <span class="fs-12 cursor-pointer btn-link"
                                                (click)="openModal(property.associatedProperty)">
                                                {{property.associatedProperty.reference}}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </span>
                        </td>
                        <td class="w-xs">{{property.businessType?.name}}</td>
                        <td class="w-xs">{{priceFormat(property.price, property?.currency)}}</td>
                        <td>{{property.store?.name}}</td>
                        <td class="status">
                            <span class="badge text-uppercase badge-soft-info">
                                <!-- {{property?.status?'Active':'Inactive'}} -->
                                <ng-container *ngIf="property?.status">
                                    {{ 't-highlight'| translate }}
                                </ng-container>
                            </span>
                        </td>
                        <td>{{createDateFormat(property.updated)}}</td>
                        <td>{{createDateFormat(property.createdAt)}}</td>
                        <td>
                            <ul class="list-inline hstack gap-2 mb-0">
                                <li class="list-inline-item" ngbTooltip="{{'t-edit' | translate}}" placement="top"
                                    container="body" *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')
                                    || permissionsService.canEditProperty(loginUser, property?.store?.id)">
                                    <a class="edit-item-btn text-primary" (click)="openModal(property)"><i
                                            class="ri-pencil-fill align-bottom  fs-16"></i></a>
                                </li>
                                <li class="list-inline-item" ngbTooltip="{{'t-view' | translate}}" placement="top"
                                    container="body"
                                    *ngIf="!permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')  && !permissionsService.canEditProperty(loginUser, property?.store?.id)">
                                    <a class="edit-item-btn text-primary" (click)="openModal(property)"><i
                                            class="ri-eye-line align-bottom  fs-16"></i></a>
                                </li>

                                <li class="list-inline-item" ngbTooltip="{{'t-delete' | translate}}" placement="top"
                                    container="body"
                                    *ngIf="permissionsService.canDeleteProperty(loginUser, property?.store?.id)">
                                    <a class="remove-item-btn text-danger" (click)="confirm(property.id)">
                                        <i class="ri-delete-bin-fill align-bottom"></i>
                                    </a>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row justify-content-md-between align-items-md-center mt-3"
            *ngIf="total>0 && !propertyFilters.highlight">
            <div class="col col-sm-6">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{'t-showing' | translate}}
                    {{startIndex}} {{'t-table-to' | translate}}
                    {{endIndex}} {{'t-table-of' | translate}} {{total}}
                    {{'t-table-entries' | translate}}
                </div>
            </div>
            <!-- Pagination -->
            <div class="col col-sm-6">
                <div class="text-sm-right me-2 float-sm-end listjs-pagination">
                    <ngb-pagination [collectionSize]="(total)" [maxSize]="6" [(page)]="page" [pageSize]="pageSize"
                        (pageChange)="refreshProperties()">
                    </ngb-pagination>
                </div>
            </div>
            <!-- End Pagination -->
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-3"
            *ngIf="total>0 && propertyFilters.highlight">
            <div class="col col-sm-6">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{'t-showing' | translate}}
                    {{startIndex}} {{'t-table-to' | translate}}
                    {{total}} {{'t-table-of' | translate}} {{total}}
                    {{'t-table-entries' | translate}}
                </div>
            </div>
        </div>

    </div>

</div>
<div class="py-4 text-center" *ngIf="noresult">
    <div>
        <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop"
            colors="primary:#405189,secondary:#0ab39c" style="width:72px;height:72px">
        </lord-icon>
    </div>
    <div class="mt-4">
        <h5>{{'t-no-result-message' | translate}}</h5>
    </div>
</div>

<app-create-edit-developments [openProposal]="openProposal" [property]="property"
    [canActivateProperties]="canActivateProperties" *ngIf="isOpenModal" [dataToFormInitDetails]="dataToFormInitDetails"
    [dataToFormInitAddress]="dataToFormInitAddress" [dataToFormInitAreasNearby]="dataToFormInitAreasNearby"
    [dataToFormInitChar]="dataToFormInitChar" [dataToFormInitAdvertisement]="dataToFormInitAdvertisement"
    [dataToFormInitAgents]="dataToFormInitAgents" [dataToFormInitPortals]="dataToFormInitPortals"
    [openModaltSubject$]="openModaltSubject$"></app-create-edit-developments>

<div class="offcanvas offcanvas-end h-100" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel"
    style="visibility: hidden;" aria-hidden="true" #property_filters_offcanvas data-bs-backdrop="false">
    <div class="offcanvas-header bg-light">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel">
            {{ 't-property-quick-filters.t-advanced' | translate }}

        </h5>
        <span class="badge border border-dark ms-1 text-body fs-12">
            {{countFilters$.getValue()}}
        </span>
        <button type="button" class="btn-close text-reset d-none" (click)="closeFilters()">
        </button>
        <button type="button" class="d-none" id="closeCBtn" data-bs-dismiss="offcanvas" aria-label="Close"
            #button_close_property_filters>
        </button>
    </div>
    <!--end offcanvas-header-->

    <div class="offcanvas-body p-1">
        <!-- <ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
            [options]="{ forceVisible: true }"> -->
        <form [formGroup]="propertiesFiltersForm" *ngIf="properties &&  openModaltSubject$.getValue()>=5">
            <div class="card">

                <div class="accordion accordion-flush filter-accordion">
                    <div class="card-body border-bottom"
                        *ngIf="permissionsService.hasPermission('VIEW_PROPERTIES_NETWORK') && !permissionsService.isRealMaster()">
                        <div class="mb-3">
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    <label for="showNetworkProperties"
                                        class="form-check-label text-uppercase fw-medium fs-12">
                                        {{'t-show-properties-network' | translate}}
                                    </label>
                                </div>
                                <div class="flex-shrink-0">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" role="switch"
                                            id="showNetworkProperties" formControlName="showNetworkProperties">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body border-bottom">
                        <div class="mb-3">
                            <label for="propertyStoreInput" class="form-label text-uppercase fs-12 fw-medium ">
                                {{ 't-m-properties.t-store' | translate }}
                            </label>
                            <ng-select [items]="stores" [multiple]="true" bindLabel="name" bindValue="id"
                                [clearable]="false" groupBy="groupDescription" class="seleect-group-item"
                                placeholder="---" formControlName="stores">
                            </ng-select>
                        </div>
                        <div class="align-items-center d-flex gap-1 mb-3" *ngIf="loginUser.role?.name==='MASTER'">
                            <div class="w-100">
                                <label for="propertyAgentInput" class="form-label text-uppercase fs-12 fw-medium ">
                                    {{ 't-m-properties.t-agents' | translate }}
                                </label>
                                <ng-select [items]="agents" [multiple]="true" bindLabel="name" bindValue="id"
                                    [clearable]="false" groupBy="groupDescription" class="seleect-group-item"
                                    placeholder="---" formControlName="agents">
                                </ng-select>
                            </div>
                            <div class="dropdown mt-4">
                                <button class="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button"
                                    data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                    <i class="ri-more-fill"></i>
                                </button>
                                <ul class="dropdown-menu p-3" style="min-width: 12rem;">
                                    <li class="py-2">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch"
                                                id="t-listing-agent" formControlName="listingAgent">
                                            <label class="form-check-label" for="t-listing-agent">
                                                {{ 't-properties-agents.t-listing-agent' | translate }}
                                            </label>
                                        </div>
                                    </li>
                                    <li class="py-2">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch"
                                                id="t-secondary-agent" formControlName="secondaryAgent">
                                            <label class="form-check-label" for="t-secondary-agent">
                                                {{ 't-properties-agents.t-secondary-agent' | translate }}
                                            </label>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="propertytypeInput" class="form-label text-uppercase fs-12 fw-medium ">
                                {{ 't-m-properties.t-property-type' | translate }}
                            </label>
                            <ng-select [items]="propertyTypes" [multiple]="true" bindLabel="description" bindValue="id"
                                placeholder="Select property type" [clearable]="false" groupBy="groupDescription"
                                class="seleect-group-item" placeholder="---" formControlName="propertyTypes">
                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{item.groupDescription==='---'?'N/A':item.groupDescription || 'Unnamed group'}}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="card-body border-bottom">
                        <div class="mb-3">
                            <label class="form-label text-uppercase fs-12 fw-medium ">{{ 't-m-properties.t-district' |
                                translate
                                }}</label>
                            <ng-select [items]="districts" [multiple]="true" bindLabel="name" bindValue="id"
                                [clearable]="false" class="seleect-group-item" placeholder="---"
                                formControlName="district"></ng-select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label text-uppercase fs-12 fw-medium ">{{ 't-m-properties.t-county' |
                                translate
                                }}</label>
                            <ng-select [items]="counties" [multiple]="true" bindLabel="name" bindValue="id"
                                [clearable]="false" class="seleect-group-item" placeholder="---"
                                formControlName="county"></ng-select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label text-uppercase fs-12 fw-medium ">{{ 't-m-properties.t-parish' |
                                translate
                                }}</label>
                            <ng-select [items]="parish" [multiple]="true" bindLabel="name" bindValue="id"
                                [clearable]="false" class="seleect-group-item" placeholder="---"
                                formControlName="parish"></ng-select>
                        </div>
                    </div>
                    <div class="card-body border-bottom">
                        <p class="text-uppercase fs-12 fw-medium">{{ 't-exclusives-only' | translate }}</p>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch" id="exclusivesOnly"
                                formControlName="exclusive">
                        </div>
                    </div>
                    <div class="card-body border-bottom">
                        <p class="text-uppercase fs-12 fw-medium">{{ 't-website-visibility' | translate }}</p>
                        <div class="d-flex flex-column gap-2">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="websiteStatus"
                                    formControlName="websiteStatus">
                                <label class="form-check-label" for="websiteStatus">
                                    {{ 't-published-website' | translate }}
                                </label>
                            </div>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="websiteHighlight"
                                    formControlName="websiteHighlight">
                                <label class="form-check-label" for="websiteHighlight">
                                    {{ 't-highlighted-website' | translate }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="card-body border-bottom">
                        <p class=" fs-12 fw-medium">
                            <span class="text-uppercase">
                                {{ 't-m-properties.t-useful-area' | translate }}
                            </span>

                            (m<sup>2</sup>)

                        </p>

                        <div class="formCost d-flex gap-2 align-items-center mt-3">
                            <input class="form-control form-control-sm" type="number" id="minUsefulArea"
                                placeholder="Min" formControlName="minUsefulArea" (blur)="touch($event)">
                            <span class="fw-semibold text-muted">
                                {{ 't-range-to' | translate }}
                            </span>
                            <input class="form-control form-control-sm" type="number" id="maxUsefulArea"
                                placeholder="Max" formControlName="maxUsefulArea" (blur)="touch($event)">
                        </div>
                    </div>
                    <div class="card-body border-bottom">
                        <p class="text-uppercase fs-12 fw-medium">
                            {{ 't-m-properties.t-year-of-construction' | translate }}
                        </p>

                        <div class="formCost d-flex gap-2 align-items-center mt-3">
                            <input class="form-control form-control-sm" type="number" id="minYearofconstructionInput"
                                placeholder="Min" formControlName="minYearofconstruction" (blur)="touch($event)">
                            <span class="fw-semibold text-muted">
                                {{ 't-range-to' | translate }}
                            </span>
                            <input class="form-control form-control-sm" type="number" id="maxYearofconstructionInput"
                                placeholder="Max" formControlName="maxYearofconstruction" (blur)="touch($event)">
                        </div>
                    </div>


                    <div class="card-body border-bottom">
                        <p class="text-uppercase fs-12 fw-medium">{{ 't-m-properties.t-price' | translate }}</p>
                        <ngx-slider [value]="propertiesFiltersForm.get('minPrice')?.value"
                            [highValue]="propertiesFiltersForm.get('maxPrice')?.value" [options]="options"
                            (valueChange)="changePrice($event)"
                            (highValueChange)="changePrice($event,false)"></ngx-slider>

                        <div class="formCost d-flex gap-2 align-items-center mt-3">
                            <input class="form-control form-control-sm" type="number" id="minPrice"
                                formControlName="minPrice">
                            <span class="fw-semibold text-muted">
                                {{ 't-range-to' | translate }}
                            </span> <input class="form-control form-control-sm" type="number" id="maxPrice"
                                formControlName="maxPrice">
                        </div>
                    </div>

                    <div class="accordion-item">
                        <h2 class="accordion-header" id="filter-conditions">
                            <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filter-collapseConditions"
                                aria-expanded="true" aria-controls="filter-collapseConditions">
                                <span class="text-uppercase fs-12 fw-medium">
                                    {{ 't-m-properties.t-condition' |translate }}
                                </span> <span
                                    class="align-middle badge border border-dark filter-badge ms-1 text-body">{{countFiltersconditions}}</span>
                            </button>
                        </h2>

                        <div id="filter-collapseConditions" class="accordion-collapse collapse "
                            aria-labelledby="filter-conditions">
                            <div class="accordion-body text-body pt-0">

                                <div class="d-flex flex-column gap-2 mt-3 filter-check">

                                    <div class="form-check" *ngFor="let condition of conditions">
                                        <input class="form-check-input" type="checkbox"
                                            id="filterCondition{{condition.id}}"
                                            formControlName="condition_{{condition.id}}">
                                        <label class="form-check-label"
                                            for="filterCondition{{condition.id}}">{{condition.description}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end accordion-item -->

                    <div class="accordion-item">
                        <h2 class="accordion-header" id="filter-businessStatus">
                            <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filter-collapseBusinessStatus"
                                aria-expanded="true" aria-controls="filter-collapseBusinessStatus">
                                <span class="text-uppercase fs-12 fw-medium">
                                    {{ 't-m-properties.t-business-status' |translate }}
                                </span> <span
                                    class="align-middle badge border border-dark filter-badge ms-1 text-body">{{countFiltersBusinessStatus}}</span>
                            </button>
                        </h2>
                        <div id="filter-collapseBusinessStatus" class="accordion-collapse collapse"
                            aria-labelledby="filter-businessStatus">
                            <div class="accordion-body text-body pt-1">
                                <div class="d-flex flex-column gap-2 filter-check">
                                    <div class="form-check" *ngFor="let bStatus of filtersBusinessStatus">
                                        <input class="form-check-input" type="checkbox" value="{{bStatus.id}}"
                                            id="filterbusinessStatus{{bStatus.id}}"
                                            formControlName="businessStatus_{{bStatus.id}}">
                                        <label class="form-check-label" for="filterbusinessStatus{{bStatus.id}}">
                                            {{bStatus.description}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end accordion-item -->
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="filter-businessTypes">
                            <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filter-collapseBusinessTypes"
                                aria-expanded="true" aria-controls="filter-collapseBusinessTypes">
                                <span class="text-uppercase fs-12 fw-medium">
                                    {{ 't-m-properties.t-business-type' |translate }}
                                </span> <span
                                    class="align-middle badge border border-dark filter-badge ms-1 text-body">{{countFiltersBusinessTypes}}</span>
                            </button>
                        </h2>
                        <div id="filter-collapseBusinessTypes" class="accordion-collapse collapse"
                            aria-labelledby="filter-businessTypes">
                            <div class="accordion-body text-body pt-1">
                                <div class="d-flex flex-column gap-2 filter-check">
                                    <div class="form-check" *ngFor="let bTypes of businessTypes">
                                        <input class="form-check-input" type="checkbox" value="{{bTypes.id}}"
                                            id="filterBusinessTypes{{bTypes.id}}"
                                            formControlName="businessTypes_{{bTypes.id}}">
                                        <label class="form-check-label" for="filterBusinessTypes{{bTypes.id}}">
                                            {{bTypes.description}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- end accordion-item -->

                    <!-- end accordion-item -->
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="filter-EC">
                            <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filter-collapseEC" aria-expanded="true"
                                aria-controls="filter-collapseEC">
                                <span class="text-uppercase fs-12 fw-medium">
                                    {{ 't-m-properties.t-energetic-certification' | translate }}
                                </span> <span
                                    class="align-middle badge border border-dark filter-badge ms-1 text-body">{{countFiltersECS}}</span>
                            </button>
                        </h2>
                        <div id="filter-collapseEC" class="accordion-collapse collapse" aria-labelledby="filter-EC">
                            <div class="accordion-body text-body pt-1">
                                <div class="d-flex flex-column gap-2 filter-check">
                                    <div class="form-check" *ngFor="let e of ecs">
                                        <input class="form-check-input" type="checkbox" value="{{e.id}}"
                                            id="filterEC{{e.id}}" formControlName="ec_{{e.id}}">
                                        <label class="form-check-label" for="filterEC{{e.id}}">
                                            {{e.description}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- end accordion-item -->
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="filter-created-at">
                            <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filter-collapseCreatedAt"
                                aria-expanded="true" aria-controls="filter-collapseCreatedAt">
                                <span class="text-uppercase fs-12 fw-medium">
                                    {{ 't-created-at' | translate }}
                                </span>
                            </button>
                        </h2>

                        <div id="filter-collapseCreatedAt" class="accordion-collapse collapse "
                            aria-labelledby="filter-created-at">
                            <div class="accordion-body text-body pt-0">
                                <div class="formCost d-flex gap-2 align-items-center mt-3">
                                    <input class="form-control form-control-sm" type="date" id="minCreatedAtInput"
                                        formControlName="minCreatedAt">
                                    <span class="fw-semibold text-muted">
                                        {{ 't-range-to' | translate }}
                                    </span>
                                    <input class="form-control form-control-sm" type="date" id="maxCreatedAtInput"
                                        formControlName="maxCreatedAt">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <h2 class="accordion-header" id="filter-updated-at">
                            <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filter-collapseUpdatedAt"
                                aria-expanded="true" aria-controls="filter-collapseUpdatedAt">
                                <span class="text-uppercase fs-12 fw-medium">
                                    {{ 't-m-properties.t-updated-at' | translate }}
                                </span>
                            </button>
                        </h2>

                        <div id="filter-collapseUpdatedAt" class="accordion-collapse collapse "
                            aria-labelledby="filter-updated-at">
                            <div class="accordion-body text-body pt-0">
                                <div class="formCost d-flex gap-2 align-items-center mt-3">
                                    <input class="form-control form-control-sm" type="date" id="minUpdatedAtInput"
                                        formControlName="minUpdatedAt">
                                    <span class="fw-semibold text-muted">
                                        {{ 't-range-to' | translate }}
                                    </span>
                                    <input class="form-control form-control-sm" type="date" id="maxUpdatedAtInput"
                                        formControlName="maxUpdatedAt">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <h2 class="accordion-header" id="filter-validated-at">
                            <button class="accordion-button bg-transparent shadow-none collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filter-collapseValidatedAt"
                                aria-expanded="true" aria-controls="filter-collapseValidatedAt">
                                <span class="text-uppercase fs-12 fw-medium">
                                    {{ 't-property-validation-date' | translate }}
                                </span>
                            </button>
                        </h2>

                        <div id="filter-collapseValidatedAt" class="accordion-collapse collapse "
                            aria-labelledby="filter-validated-at">
                            <div class="accordion-body text-body pt-0">
                                <div class="formCost d-flex gap-2 align-items-center mt-3">
                                    <input class="form-control form-control-sm" type="date" id="minValidatedAtInput"
                                        formControlName="minValidatedAt">
                                    <span class="fw-semibold text-muted">
                                        {{ 't-range-to' | translate }}
                                    </span>
                                    <input class="form-control form-control-sm" type="date" id="maxValidatedAtInput"
                                        formControlName="maxValidatedAt">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <!--end offcanvas-body-->
    <div class="offcanvas-footer border-top p-3 text-center hstack gap-2">
        <button class="btn btn-light w-100" (click)="resetPropertiesFiltersForm()">
            {{ 't-clear-filter'| translate }}
        </button>
        <button type="submit" class="btn btn-outline-primary btn-label waves-effect waves-light w-100"
            (click)="filtersProperties();" [ngClass]="{'btn-load':isCountPropertyFilters}">
            <i class="ri-search-line label-icon align-middle fs-16 me-2"></i>
            <ng-container *ngIf="!isCountPropertyFilters">
                {{totalPropertyFilters}} {{ 't-properties'| translate }}
            </ng-container>

            <span class="d-flex align-items-center" *ngIf="isCountPropertyFilters">
                <span class="spinner-border flex-shrink-0" role="status">
                    <span class="visually-hidden"> {{ 't-loading'| translate }}...</span>
                </span>
                <span class="flex-grow-1 ms-2">
                    {{ 't-loading'| translate }}...
                </span>
            </span>
        </button>
    </div>
    <!--end offcanvas-footer-->

</div>
<div (click)="closeCanvas(null, true)" class="offcanvas-backdrop fade show" *ngIf="showPropertyFilerts"></div>

<ng-template let-modal #modalPreview>
    <div class="modal-header border-bottom rounded p-3">
        <div class="d-flex align-items-center gap-2">
            <h5 *ngIf="propertyToPreview && propertyToPreview?.title" class="modal-title" id="userModalLabel">
                {{'t-property-details' | translate}}
            </h5>
            <span class="badge badge-soft-primary fs-13">Ref: {{propertyToPreview.reference}}</span>
            <!-- Excel (com "Vendido por"): só MASTER e STORE OPERATOR da loja do empreendimento -->
            <button *ngIf="propertyToPreview?.units?.length && canExportUnitsExcel" type="button"
                class="btn btn-success btn-sm" [disabled]="!!exportingUnitsFormat"
                (click)="exportUnits('excel')">
                <span *ngIf="exportingUnitsFormat === 'excel'" class="spinner-border spinner-border-sm align-middle"></span>
                <i *ngIf="exportingUnitsFormat !== 'excel'" class="ri-file-excel-2-line align-bottom"></i>
            </button>
            <button *ngIf="propertyToPreview?.units?.length" type="button"
                class="btn btn-danger btn-sm" [disabled]="!!exportingUnitsFormat"
                (click)="exportUnits('pdf')">
                <span *ngIf="exportingUnitsFormat === 'pdf'" class="spinner-border spinner-border-sm align-middle"></span>
                <i *ngIf="exportingUnitsFormat !== 'pdf'" class="ri-file-pdf-line align-bottom"></i>
            </button>
        </div>
        <button type="button" class="btn-close" aria-label="Close" id="close-modal"
            (click)="modal.dismiss('Cross click')">
        </button>
    </div>
    <div class="modal-body p-0">
        <div class="mx-0 row">
            <div class="border-end col-md-6 p-3 rsi">
                <ngb-carousel [activeId]="activeSliderId" #carouselPreview>
                    <ng-template *ngFor="let image of propertyToPreview?.images; let i = index" ngbSlide
                        [id]="'ngb-slide-' + i">
                        <div class="picsum-img-wrapper">
                            <img [src]="pathImage + image?.url" class="w-100 mh-5" />
                        </div>
                        <div *ngIf="image?.description" class="carousel-caption">
                            <h3 class="text-white">{{image?.description}}</h3>
                        </div>
                    </ng-template>
                </ngb-carousel>
                <div class="details mt-3">
                    <h3 class="text-black">{{propertyToPreview.title}}</h3>
                    <div class="d-flex align-items-center justify-content-between">
                        <h3 class="fw-bold mb-0 text-primary" *ngIf="propertyToPreview.price">
                            {{priceFormat(propertyToPreview.price)}}</h3>
                        <div class="d-flex align-items-center gap-2">
                            <span *ngIf="propertyToPreview.exclusive"
                                class="badge badge-soft-success fs-14">{{'t-exclusive' |
                                translate}}</span>
                            <span *ngIf="propertyToPreview.isResale" class="badge badge-soft-warning fs-14">{{
                                propertyToPreview.resaleOf?.reference
                                  ? ('t-resale-of' | translate:{ reference: propertyToPreview.resaleOf?.reference })
                                  : ('t-resale' | translate) }}</span>
                            <span *ngIf="propertyToPreview.businessType"
                                class="badge badge-soft-primary fs-14">{{propertyToPreview.businessType}}</span>
                        </div>
                    </div>
                </div>
                <div class="align-items-center d-flex justify-content-around mt-3">
                    <div *ngIf="propertyToPreview.bedrooms" class="division-prev border p-2">
                        <i class="mdi mdi-bed fs-1 text-primary"></i>
                        <span class="text-muted">{{'t-mls-filters.t-bedrooms' | translate}}</span>
                        {{propertyToPreview.bedrooms}}
                    </div>
                    <div *ngIf="propertyToPreview.bathrooms" class="division-prev border p-2">
                        <i class="mdi mdi-bathtub fs-1 text-primary"></i>
                        <span class="text-muted">{{'t-mls-filters.t-bathrooms' | translate}}</span>
                        {{propertyToPreview.bathrooms}}
                    </div>
                    <div *ngIf="propertyToPreview.usefulArea" class="division-prev border p-2">
                        <i class="mdi mdi-ruler-square fs-1 text-primary"></i>
                        <span class="text-muted">{{'t-m-properties.t-useful-area' | translate}}</span>
                        {{propertyToPreview.usefulArea}}
                    </div>
                </div>
                <h4 class=" d-flex align-items-center"><i class="mdi mdi-information text-primary"></i>
                    {{'t-property-preview.t-info' | translate}}</h4>
                <div class="row g-2 mt-3">
                    <div *ngIf="propertyToPreview.propertyType && propertyToPreview.propertyType !== '---'"
                        class="col-md-6">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-m-properties.t-property-type' | translate}}: </span>
                            <span>{{propertyToPreview.propertyType}}</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.condition && propertyToPreview.condition !== '---'" class="col-md-6">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-m-properties.t-status' | translate}}: </span>
                            <span>{{propertyToPreview.condition}}</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.yearOfConstruction" class="col-md-6">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-m-properties.t-year-of-construction' | translate}}: </span>
                            <span>{{propertyToPreview.yearOfConstruction | date: 'yyyy'}}</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.grossArea" class="col-md-6">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-m-properties.t-gross-area' | translate}}: </span>
                            <span>{{propertyToPreview.grossArea}} m²</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.ec" class="col-md-6">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-m-properties.t-energetic-certification' | translate}}: </span>
                            <span>{{propertyToPreview.ec}}</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.createdAt" class="col-md-6">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-created-at' | translate}}: </span>
                            <span>{{propertyToPreview.createdAt | date: 'dd/MM/yyyy'}}</span>
                        </div>
                    </div>
                </div>
                <h4 class="mt-3 d-flex align-items-center"><i class="mdi mdi-map-marker text-primary"></i>
                    {{'t-m-properties.t-location' | translate}}
                </h4>
                <div class="row g-2 mt-3 rsi">
                    <div *ngIf="propertyToPreview.district && propertyToPreview.district !== '---'" class="col-12">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-m-properties.t-district' | translate}}: </span>
                            <span>{{propertyToPreview.district}}</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.county && propertyToPreview.county !== '---'" class="col-12">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-m-properties.t-county' | translate}}: </span>
                            <span>{{propertyToPreview.county}}</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.parish && propertyToPreview.parish !== '---'" class="col-12">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-m-properties.t-parish' | translate}}: </span>
                            <span>{{propertyToPreview.parish}}</span>
                        </div>
                    </div>
                </div>
                <!-- <h4 *ngIf="propertyToPreview.owner" class="mt-3 d-flex align-items-center"><i
                        class="mdi mdi-account-box text-primary"></i>
                    {{'t-lead-owner' | translate}}</h4>
                <div class="row g-2 mt-3">
                    <div *ngIf="propertyToPreview.owner?.name" class="col-12">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-name' | translate}}: </span>
                            <span>{{propertyToPreview.owner?.name}}</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.owner?.phone" class="col-12">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-phone' | translate}}: </span>
                            <span>{{propertyToPreview.owner?.phone}}</span>
                        </div>
                    </div>
                    <div *ngIf="propertyToPreview.owner?.email" class="col-12">
                        <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                            <span class="text-muted">{{'t-email' | translate}}: </span>
                            <span>{{propertyToPreview.owner?.email}}</span>
                        </div>
                    </div>
                </div> -->
                <h4 *ngIf="propertyToPreview.documents && propertyToPreview.documents.length > 0"
                    class="mt-3 d-flex align-items-center">
                    <i class="mdi mdi-file-sign text-primary"></i>
                    {{'t-m-properties.t-documents' | translate}}
                </h4>
                <div *ngIf="propertyToPreview.documents && propertyToPreview.documents.length > 0"
                    class="row g-2 mt-3 rsi">
                    <div *ngFor="let doc of propertyToPreview.documents" class="col-12">
                        <div class="p-2 border d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <i class="mdi mdi-file-document text-success fs-20"></i>
                                <span class="text-black ms-2">{{doc.description !== 'finishingMapPropertyDocument' ?
                                    doc.description : 't-developments.t-finishing-map' | translate}} </span>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <a href="{{pathDocuments + doc.url}}" target="_blank"><i
                                        class="mdi mdi-download text-success fs-20"></i></a>
                                <a href="{{pathDocuments + doc.url}}/preview" target="_blank"><i
                                        class="mdi mdi-eye-outline text-success fs-20"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 p-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h4 class="d-flex align-items-center mb-0">
                        <i class="mdi mdi-office-building text-primary"></i>
                        <span class="ms-2">{{'t-property-preview.t-building-preview' | translate}}</span>
                    </h4>
                </div>

                <div class="colors-legend d-flex gap-3 mb-3">
                    <div class="legend-item d-flex align-items-center">
                        <span class="legend-color status-available"></span>
                        <span>{{'t-property-preview.t-available' | translate}}</span>
                    </div>
                    <div class="legend-item d-flex align-items-center" *ngIf="shouldShowInProposalLegend()">
                        <span class="legend-color status-in-proposal"></span>
                        <span>{{ 't-property-preview.t-in-proposal' | translate }}</span>
                    </div>
                    <div class="legend-item d-flex align-items-center">
                        <span class="legend-color status-reserved"></span>
                        <span>{{ 't-property-preview.t-reserved' | translate }}</span>
                    </div>
                    <div class="legend-item d-flex align-items-center">
                        <span class="legend-color status-sold"></span>
                        <span>{{ 't-property-preview.t-sold' | translate }}</span>
                    </div>
                </div>

                <div class="mb-3 btn-group" *ngIf="unitsBlocks.length > 1">
                    <button type="button" class="btn btn-sm block-tab-btn" *ngFor="let block of unitsBlocks"
                        [ngClass]="block.id === activeUnitsBlockId ? 'btn-primary' : 'btn-outline-primary'"
                        (click)="setActiveUnitsBlock(block.id)">
                        {{ block.name }}
                        <span class="badge ms-1"
                            [ngClass]="block.id === activeUnitsBlockId ? 'text-bg-light' : 'text-bg-primary bg-primary'">
                            {{ block.units.length }}
                        </span>
                    </button>
                </div>

                <!-- Container principal -->
                <div class="floors-organizer">
                    <!-- Zona de Drop para adicionar andar no topo -->
                    <div class="add-floor-zone" *ngIf="draggedUnit" [class.active]="showAddFloorTop"
                        (dragover)="onDragOverAddFloor($event, 'top')" (dragleave)="onDragLeaveAddFloor('top')"
                        (drop)="onDropAddFloor($event, 'top')">
                        <i class="mdi mdi-plus-circle"></i>
                        <span>{{ 't-property-preview.t-add-top-floor' | translate }}</span>
                    </div>

                    <!-- Lista de andares -->
                    <div class="floors-list">
                        <div *ngFor="let floor of floors; let i = index" class="floor-card"
                            [class.ground-floor]="floor.floorNumber === 0" [class.basement]="floor.floorNumber < 0">

                            <!-- Cabeçalho do andar -->
                            <div class="floor-card-header">
                                <div class="floor-title">
                                    <span class="floor-number">{{ getFloorLabel(floor.floorNumber) }}</span>
                                    <span class="badge" [ngClass]="{
                            'badge-soft-primary': floor.floorNumber > 0,
                            'badge-soft-warning': floor.floorNumber === 0,
                            'badge-soft-secondary': floor.floorNumber < 0
                        }">{{ floor.units.length }} {{ floor.units.length === 1 ? 'fração' : 'frações' }}</span>
                                </div>
                                <!-- <button class="btn-icon-remove" (click)="removeFloor(floor)"
                                    *ngIf="floor.units.length === 0" title="Remover andar">
                                    <i class="mdi mdi-trash-can-outline"></i>
                                </button> -->
                            </div>

                            <!-- Área de drop das frações -->
                            <div class="floor-units-area" [class.empty]="floor.units.length === 0"
                                (dragover)="onDragOver($event)" (drop)="onDropOnFloor($event, floor)">

                                <!-- Mensagem quando vazio -->
                                <div *ngIf="floor.units.length === 0" class="empty-state">
                                    <i class="mdi mdi-home-import-outline"></i>
                                    <p>{{ 't-property-preview.t-drag-units' | translate }}</p>
                                </div>

                                <!-- Grid de frações -->
                                <div class="units-grid" *ngIf="floor.units.length > 0">
                                    <div *ngFor="let unit of floor.units" (dblclick)="onUnitClick(unit)"
                                        ngbTooltip="{{'t-double-click-to-open' | translate}}" class="unit-card"
                                        [draggable]="permissionsService.checkAgentPermission(fullPropertyToPreview?.mainAgent, 'EDIT_PROPERTIES') 
                                          || permissionsService.canEditProperty(loginUser, fullPropertyToPreview?.store?.id)"
                                        (dragstart)="onDragStart($event, unit)" (dragend)="onDragEnd($event)"
                                        [title]="unit.title">

                                        <!-- Status visual -->
                                        <div class="unit-status-bar" [ngClass]="{
                                'status-in-proposal': isUnitInProposal(unit),
                                'status-available': unit.status?.code === 'AVAILABLE' && !isUnitInProposal(unit),
                                'status-reserved': ['RESERVED'].includes(unit.status?.code || '') && !isUnitInProposal(unit),
                                'status-sold': ['SOLD', 'RENTED'].includes(unit.status?.code || '') && !isUnitInProposal(unit)
                            }"></div>

                                        <!-- Conteúdo do card -->
                                        <div class="unit-content">
                                            <div class="unit-header">
                                                <span class="unit-reference">{{ unit.reference }}</span>
                                                <span class="text-muted fw-medium">{{ unit.fraction }}</span>
                                                <!-- <i class="mdi mdi-drag-vertical drag-handle"></i> -->
                                            </div>

                                            <div class="unit-info">
                                                <span *ngIf="unit.bedrooms" class="info-item">
                                                    <i class="mdi mdi-bed"></i> {{ unit.bedrooms }}
                                                </span>
                                                <span *ngIf="unit.bathrooms" class="info-item">
                                                    <i class="mdi mdi-bathtub"></i> {{ unit.bathrooms }}
                                                </span>
                                                <span *ngIf="unit.price" class="info-item price" [title]="priceFormat(unit.price)">
                                                    {{ priceFormat(unit.price) }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Zona de Drop para adicionar andar na base -->
                    <div class="add-floor-zone bottom" *ngIf="draggedUnit" [class.active]="showAddFloorBottom"
                        (dragover)="onDragOverAddFloor($event, 'bottom')" (dragleave)="onDragLeaveAddFloor('bottom')"
                        (drop)="onDropAddFloor($event, 'bottom')">
                        <i class="mdi mdi-plus-circle"></i>
                        <span>{{ 't-property-preview.t-add-bottom-floor' | translate }}</span>
                    </div>
                </div>

                <!-- Frações não atribuídas -->
                <div class="unassigned-section mt-4">
                    <div class="section-header">
                        <h5>
                            <i class="mdi mdi-home-group"></i>
                            {{ 't-property-preview.t-units-without-floor' | translate }}
                        </h5>
                        <span class="badge badge-soft-warning">{{ unassignedUnits.length }}</span>
                    </div>

                    <div class="unassigned-area" [class.empty]="unassignedUnits.length === 0"
                        (dragover)="onDragOver($event)" (drop)="onDropOnUnassigned($event)">

                        <!-- Estado vazio -->
                        <div *ngIf="unassignedUnits.length === 0" class="empty-state">
                            <i class="mdi mdi-check-circle-outline text-success"></i>
                            <p>{{ 't-property-preview.t-units-with-floor' | translate }}</p>
                        </div>

                        <!-- Grid de frações não atribuídas -->
                        <div class="units-grid compact" *ngIf="unassignedUnits.length > 0">
                            <div *ngFor="let unit of unassignedUnits"
                                [draggable]="permissionsService.checkAgentPermission(fullPropertyToPreview?.mainAgent, 'EDIT_PROPERTIES') 
                                          || permissionsService.canEditProperty(loginUser, fullPropertyToPreview?.store?.id)" class="unit-card unassigned"
                                (dragstart)="onDragStart($event, unit)" (dragend)="onDragEnd($event)"
                                [title]="unit.title" (dblclick)="onUnitClick(unit)">

                                <!-- Status visual -->
                                <div class="unit-status-bar" [ngClass]="{
                        'status-in-proposal': isUnitInProposal(unit),
                        'status-available': unit.status?.code === 'AVAILABLE' && !isUnitInProposal(unit),
                        'status-reserved': ['PROSPECTING', 'RESERVED'].includes(unit.status?.code || '') && !isUnitInProposal(unit),
                        'status-sold': ['SOLD', 'RENTED'].includes(unit.status?.code || '') && !isUnitInProposal(unit)
                    }"></div>

                                <!-- Conteúdo do card -->
                                <div class="unit-content">
                                    <div class="unit-header">
                                        <span class="unit-reference">{{ unit.reference }}</span>
                                        <i class="mdi mdi-drag-vertical drag-handle"></i>
                                    </div>

                                    <div class="unit-info">
                                        <span *ngIf="unit.bedrooms" class="info-item">
                                            <i class="mdi mdi-bed"></i> {{ unit.bedrooms }}
                                        </span>
                                        <span *ngIf="unit.bathrooms" class="info-item">
                                            <i class="mdi mdi-bathtub"></i> {{ unit.bathrooms }}
                                        </span>
                                        <span *ngIf="unit.price" class="info-item price" [title]="priceFormat(unit.price)">
                                            {{ priceFormat(unit.price) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="enablePropertyNotes && propertyNotesAccess?.canRead" class="mt-4">
                    <button type="button"
                        class="btn btn-outline-primary w-100 d-flex justify-content-between align-items-center"
                        (click)="togglePropertyNotes()">
                        <span>{{ 't-view-notes' | translate }}</span>
                        <i class="mdi fs-5"
                            [ngClass]="propertyNotesExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"></i>
                    </button>

                    <div *ngIf="propertyNotesExpanded" class="border rounded mt-2 p-3">
                        <ng-container *ngIf="propertyNotesAccess?.canWrite">
                        <label class="form-label fw-semibold">{{ 't-property-notes-new-note' | translate }}</label>
                        <textarea class="form-control" rows="3"
                            [placeholder]="'t-property-notes-placeholder' | translate" [value]="newPropertyNote"
                            (input)="newPropertyNote = $any($event.target).value"></textarea>
                        <div class="mt-2">
                            <input #propertyNotesFileInput type="file" class="form-control form-control-sm" multiple
                                (change)="onPropertyNoteFilesSelected($event)">
                            <small class="text-muted" *ngIf="propertyNoteFilesToUpload.length > 0">
                                {{ 't-property-notes-files-selected' | translate:{ count:
                                propertyNoteFilesToUpload.length } }}
                            </small>
                        </div>
                        <div class="d-flex justify-content-end mt-2">
                            <button type="button" class="btn btn-sm btn-primary"
                                [disabled]="propertyNotesSaving || (!newPropertyNote?.trim() && propertyNoteFilesToUpload.length === 0)"
                                (click)="addPropertyNote()">
                                <span *ngIf="!propertyNotesSaving">{{ 't-property-notes-add-note' | translate }}</span>
                                <span *ngIf="propertyNotesSaving">
                                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                                    {{ 't-property-notes-saving' | translate }}
                                </span>
                            </button>
                        </div>
                        </ng-container>

                        <div class="mt-3" *ngIf="propertyNotesLoading">
                            <div class="d-flex justify-content-center">
                                <div class="spinner-border text-primary" role="status"></div>
                            </div>
                        </div>

                        <div class="mt-3" *ngIf="!propertyNotesLoading && propertyNotes.length === 0">
                            <small class="text-muted">{{ 't-property-notes-empty' | translate }}</small>
                        </div>

                        <div class="mt-3" *ngIf="!propertyNotesLoading && propertyNotes.length > 0"
                            style="max-height: 260px; overflow-y: auto;">
                            <div *ngFor="let note of propertyNotes" class="border rounded p-2 mb-2">
                                <div class="d-flex justify-content-between mb-1">
                                    <small class="fw-semibold">{{ note?.createdByName || note?.createdBy || '-'
                                        }}</small>
                                    <small class="text-muted">{{ formatPropertyNoteDate(note?.createdAt) }}</small>
                                </div>
                                <div class="mb-1">{{ note?.description || '-' }}</div>
                                <div *ngIf="note?.files?.length > 0" class="d-flex flex-column gap-1 mt-2">
                                    <a *ngFor="let file of note.files" [href]="getPropertyNoteFileUrl(note, file)"
                                        target="_blank" rel="noopener noreferrer" class="text-decoration-none">
                                        <i class="mdi mdi-paperclip"></i>
                                        <small>{{ file?.originalName || file?.fileName }}</small>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer justify-content-between align-items-center">
        <div class="status-prev d-flex align-items-center gap-1">
            <span class="rounded-circle" [ngClass]="{
      'bg-success': propertyToPreview.businessStatus?.code === 'AVAILABLE',
      'bg-warning': ['PROSPECTING', 'TO_VALIDATE', 'CPCV', 'DEED'].includes(propertyToPreview.businessStatus?.code),
      'bg-info': ['RENTED', 'RESERVED', 'LEASED'].includes(propertyToPreview.businessStatus?.code),
      'bg-danger': ['CANCELED', 'REMOVED', 'DECLINED', 'SOLD'].includes(propertyToPreview.businessStatus?.code)
    }"></span><span>{{ propertyToPreview.businessStatus?.name }}</span>
        </div>
        <button (click)="editPropertyByPreview(); modal.dismiss()" type="button"
            class="btn btn-primary">{{'t-m-properties.t-edit-property' | translate}}</button>
    </div>
</ng-template>
